import type { InvestmentNote, InvestmentExposureEntry } from "@eu.mdotm.api/sphere";
import { Divider } from "$root/components/Divider";
import { AgGridTooltipWrapper } from "$root/third-party-integrations/ag-grid/ag-grid";
import { Text, Column, Row, Icon } from "@mdotm/shadcn/legacy/components";
import { ForEach } from "@mdotm/utils/react-extra";
import { Map } from "immutable";

const exposureColorMap = Map([
	["EQUITY", "#33c8ff"],
	["FIXED-INCOME", "#ffd866"],
	["FIXED_INCOME", "#ffd866"],
	["COMMODITIES", "#f69b6f"],
	["ALTERNATIVE", "#dd8596"],
	["MONEY-MARKET", "#8c99d9"],

	["Equity", "#33c8ff"],
	["Fixed Income", "#ffd866"],
	["Commodities", "#f69b6f"],
	["Alternative", "#dd8596"],
	["Money Market", "#8c99d9"],
]);

function InvestmentTooltip(props: {
	name?: string;
	lastActionNote?: InvestmentNote;
	macroAssetClassExposure?: InvestmentExposureEntry[];
	macroAssetClassExposureEnhanced?: InvestmentExposureEntry[];
}): React.JSX.Element {
	return (
		<AgGridTooltipWrapper className="w-[224px]">
			<Text as="p" type="Body/M/Bold" className="truncate text-ellipsis mb-2" title={props.name ?? ""}>
				{props.name}
			</Text>
			<Column gap={16}>
				<ForEach
					collection={
						!props.macroAssetClassExposureEnhanced?.length
							? [{ title: "CURRENT", macroAssetClassExposure: props.macroAssetClassExposure }]
							: [
									{ title: "CURRENT", macroAssetClassExposure: props.macroAssetClassExposure },
									{ title: "PROPOSAL", macroAssetClassExposure: props.macroAssetClassExposureEnhanced },
								]
					}
				>
					{({ title, macroAssetClassExposure }) => (
						<div>
							<Text as="p" type="Body/M/Book" className="truncate text-ellipsis">
								{title}
							</Text>
							{props.lastActionNote?.text && (
								<Text as="p" type="Body/M/Book" className="line-clamp-4">
									{props.lastActionNote.text}
								</Text>
							)}
							<Divider className="my-2" />
							<Column gap={2}>
								<ForEach collection={macroAssetClassExposure ?? []}>
									{(item) => (
										<Row alignItems="center">
											<Icon icon="previous-position" color={exposureColorMap.get(item.firstQualityLevel ?? "")} />
											<Text
												as="p"
												type="Body/S/Book"
												className="px-1 text-center truncate"
												title={item.firstQualityLevel ?? "_"}
											>
												{item.firstQualityLevel ?? "_"}
											</Text>
											<Text as="p" type="Body/S/Bold" className="ml-auto mr-0">
												{item.weight ?? 0}%
											</Text>
										</Row>
									)}
								</ForEach>
							</Column>
						</div>
					)}
				</ForEach>
			</Column>
		</AgGridTooltipWrapper>
	);
}

export default InvestmentTooltip;
